import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {QUESTION_STATISTICS_FRAGMENT} from "../definitions/fragments";
import {ItemClassificationType} from "../definitions/enums";
import {useMemo} from "react";
import {QuestionStatisticsModel} from "../models/domain/questionStatisticsModel";
import {QuestionStatisticsType} from "../definitions/types";

export const useProductQuestionStatisticsFragment = () => {
    const {productId, primaryId} = useAppContext();

    const {complete, data} = useFragment({
        fragment: QUESTION_STATISTICS_FRAGMENT,
        fragmentName: "QuestionStatisticsFragment",
        from: {
            __typename: "QuestionStatistics",
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        },
    });

    const model = useMemo(() => complete && data ?
        new QuestionStatisticsModel(data as QuestionStatisticsType) :
        new QuestionStatisticsModel(null), [complete, data]);

    return {loading: !complete, model};
}